var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "b58029ff-e80b-4acc-93c7-1727c7df1104",
    "data-name": "Layer 1",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "orange",
    d: "M12.375,16.7c1.9678,0,2.7437,1.9238,2.8794,2.9409l.9912-.1318C16.07,18.1919,15.0352,15.7,12.375,15.7c-2.6846,0-3.56,2.5132-3.6489,3.8418l.998.0664C9.7261,19.5791,9.9453,16.7,12.375,16.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "orange",
    d: "M26.3252,16.7c1.9668,0,2.7432,1.9238,2.88,2.9414l.99-.1328C30.02,18.1914,28.9844,15.7,26.3252,15.7c-2.6836,0-3.5606,2.5127-3.6494,3.8418l.998.0664C23.6758,19.58,23.8965,16.7,26.3252,16.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "orange",
    d: "M20.25,35.7246c-7.1958,0-11.2275-5.9639-12.354-9.1172l-.9414.336c1.2085,3.3828,5.5425,9.7812,13.2954,9.7812,7.7363,0,12.5137-6.3789,13.96-9.7519l-.92-.3946C31.9346,29.7422,27.4648,35.7246,20.25,35.7246Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "orange",
    d: "M22.5,0A22.5,22.5,0,1,0,45,22.5,22.5253,22.5253,0,0,0,22.5,0Zm0,44A21.5,21.5,0,1,1,44,22.5,21.5242,21.5242,0,0,1,22.5,44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.c3342618a98ebc00820fda20722bcb21.svg";
export { ForwardRef as ReactComponent };